import {requestToServer} from "./main"
import {debounce} from "./main";

class Auth{

    constructor() {
        this.userInput = document.querySelector('.div-user input')
        this.codeBtn = document.querySelector('.div-receive-code a')
        this.textInfoDiv = document.querySelector('.info');
        this.textInfo = document.querySelector('.info span');

        this.setTextInfo('Первая часть адреса почты до @v-k-b.ru');

        if (this.userInput){
            this.userInput.addEventListener("keydown", this.handlerUserChange)
            this.changeFunction = debounce(this.getUserInfo, 500);
        }
        if (this.codeBtn){
            this.codeBtn.addEventListener('click', this.handlerCodeClick)
        }
    }

    handlerCodeClick = async () => {
        console.log(this.userInput.value);
        if(this.codeBtn.classList.contains('disabled')) {
            return;
        }

        this.codeBtn.classList.add('disabled');
        const saverValue = this.codeBtn.value;
        let delayed = 30;
        const intervalHandler = setInterval(()=>{
            delayed--;
            this.codeBtn.value = `Осталось ${delayed} сек`;
            if (delayed === 0){
                clearInterval(intervalHandler);
                this.codeBtn.value = saverValue;
                this.codeBtn.classList.remove('disabled');
            }
        }, 1000);
        if  (this.userInput.value) {
            try {
                const f = await requestToServer('/Service/sendCode', `login=${this.userInput.value}`);
                this.setTextInfo('Ссылка на регистрацию отправлена, проверьте почту');
            } catch (e) {
                this.setTextInfo('Что-то пошло не так!')
            }
        }
    }

    getUserInfo = async () => {
        let userName = this.userInput.value;
        if (!userName) {
            this.codeBtn.classList.add('disabled');
            return
        }
        if (userName.indexOf('@') == -1){
            userName += '@v-k-b.ru';
        }
        try {
            const f = await requestToServer('/Service/checkUserName', `userName=${userName}`);
            //console.log(f)
            if (f.data.code == 0) {
                this.staff_id = f.data.staff_id;
                this.codeBtn.classList.remove('disabled');
                this.setTextInfo('Нажмите получить код');
            } else if (f.data.code == 2) {
                this.setTextInfo('Такой пользователь уже существует', 'bg-danger')
                this.codeBtn.classList.add('disabled');
            } else {
                this.setTextInfo('Такой пользователь не найден', 'bg-danger')
                this.codeBtn.classList.add('disabled');
            }
        } catch (e) {
            this.codeBtn.classList.add('disabled');
        }
    }

    handlerUserChange = ()=>{
        this.changeFunction();
    }

    setTextInfo = (text, className = 'bg-info') => {
        if (this.textInfo) {
            this.textInfo.textContent = text;
            if (this.textInfoDiv && !this.textInfoDiv.classList.contains(className)) {
                this.textInfoDiv.classList.remove('bg-info');
                this.textInfoDiv.classList.remove('bg-danger');
                this.textInfoDiv.classList.add(className);
            }
        }

    }
}

export default new Auth();
